import { render } from "./HomeAbout.vue?vue&type=template&id=529dbaec&scoped=true"
import script from "./HomeAbout.vue?vue&type=script&lang=js"
export * from "./HomeAbout.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-529dbaec"

export default script